module.exports = __webpack_public_path__ + "static/media/1015862.6e74eead.png";